import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import React, { useState } from 'react'
import { Paginator, Params } from './utils'

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  filterControl: {
    width: '70%',
  },
}))

interface FilterWidgetProps {
  label: string
  defaultValue?: any
  onChange: (obj: any, value: string) => void
}

export interface Filter {
  id: string
  label: string
  options?: Record<string, string> | Array<{ guid: string; name: string }>
  widget?: React.FC<FilterWidgetProps>
}

interface FilterDialogProps {
  open: boolean
  onClose: () => void
  onFilterApplied?: () => void
  filters?: Filter[]
  paginator: Paginator
}

export const FilterDialog = (props: FilterDialogProps) => {
  const { open, filters, onClose, paginator, onFilterApplied } = props
  const defaults = filters
    ? filters.reduce((obj, filter: Filter) => {
        obj[filter.id] = null
        return obj
      }, {} as Params)
    : {}
  const [filterObjects, setFilterObjects] = useState<{[key: string]: any}>({...defaults})
  const [filterValues, setFilterValues] = useState<Params>(defaults)

  const handleApplyFilter = () => {
    paginator.patchFilters(filterValues)
    onFilterApplied?.()
    onClose()
  }
  const handleClearFilter = () => {
    setFilterObjects(defaults)
    setFilterValues(defaults)
    paginator.patchFilters(defaults)
  }
  const classes = useStyles()
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Filter</DialogTitle>
      <DialogContent>
        <Grid container spacing={6}>
          {filters?.map((filter) => {
            const value = filterValues[filter.id]
              ? (filterValues[filter.id] as string).split(',')
              : []
            if (filter.widget) {
              return (
                <Grid item key={filter.id} xs={12}>
                  <filter.widget
                    label={filter.label}
                    defaultValue={filterObjects[filter.id]}
                    onChange={(obj, value) => {
                      setFilterObjects({ ...filterObjects, [filter.id]: obj })
                      setFilterValues({ ...filterValues, [filter.id]: value })
                    }}
                  />
                </Grid>
              )
            }
            if (filter.options) {
              return (
                <Grid item key={filter.id} xs={12}>
                  <FormControl key={filter.id} className={classes.filterControl}>
                    <InputLabel id={filter.id}>{filter.label}</InputLabel>
                    <Select
                      id={filter.id}
                      name={filter.id}
                      label={filter.label}
                      multiple
                      onChange={(event: React.ChangeEvent<{ value: any }>) => {
                        const selectedOptions = event.target.value
                        const selectedOptionsString = selectedOptions.join(',')
                        setFilterValues({ ...filterValues, [filter.id]: selectedOptionsString })
                      }}
                      value={value}
                    >
                      {Array.isArray(filter.options)
                        ? filter.options.map(({ guid, name }) => (
                            <MenuItem key={guid} value={guid}>
                              {name && name[0].toUpperCase() + name.slice(1)}
                            </MenuItem>
                          ))
                        : Object.entries(filter.options).map(([key, value]) => (
                            <MenuItem key={key} value={key}>
                              {value[0].toUpperCase() + value.slice(1)}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              )
          }
          })}
        </Grid>
      </DialogContent>
      <Box mt={20} />
      <DialogActions>
        <Button onClick={handleClearFilter} color="primary">
          Clear Filter
        </Button>
        <Button onClick={handleApplyFilter} color="primary" variant="contained" autoFocus>
          Apply Filter
        </Button>
      </DialogActions>
    </Dialog>
  )
}
